import { errorText, rejectionReasonText } from '@/utils/error-text'

type Track = (eventName: string, properties?: Record<string, unknown>) => void

/**
 * Reports uncaught errors and unhandled promise rejections to analytics, with
 * their text cut to `ERROR_TEXT_LIMIT` characters as the customer app does: a
 * stack or a rejection reason can carry the member data the dashboard shows.
 */
export function trackUncaughtErrors(track: Track, target: Window = window): void {
  target.addEventListener('error', (event: ErrorEvent) => {
    track('javascript_error', {
      message: errorText(event.message),
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: errorText(event.error?.stack),
    })
  })

  target.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    track('unhandled_promise_rejection', {
      reason: rejectionReasonText(event.reason),
    })
  })
}
